export default __webpack_public_path__ + "static/lframe-home-7213d6804d7a861b8e9b1b0c6f593553.webp";